import { Directive, Input, OnChanges } from "@angular/core";
import {
  NG_VALIDATORS,
  UntypedFormControl,
  Validators,
  Validator
} from "@angular/forms";

@Directive({
  selector: "[uniqueString][ngModel]",
  providers: [
    { provide: NG_VALIDATORS, useExisting: UniqueStringValidator, multi: true }
  ]
})
export class UniqueStringValidator implements OnChanges, Validator {
  @Input("uniqueString")
  key: Array<string>;
  validatorFn: any = Validators.nullValidator;

  constructor() {
  }

  ngOnChanges(): void {
    if (this.key) {
      this.validatorFn = this.configureValidator(this.key);
    } else {
      this.validatorFn = Validators.nullValidator;
    }
  }

  configureValidator(forbiddenValues: Array<any>) {
    return currentValue => {
      let result = null;
      if(currentValue) {
        result = forbiddenValues.some(value => value.trim().toLowerCase() === currentValue.trim().toLowerCase());
      }
      return result ? { uniqueString: "wrong" } : null;
    };
  }

  validate(control: UntypedFormControl) {
    return this.validatorFn(control.value);
  }
}
